import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Helmet } from 'react-helmet';
interface MainLayoutProps {
  onLogout?: () => void;
}
export function MainLayout({
  onLogout
}: MainLayoutProps) {
  const location = useLocation();
  // Set default meta tags that can be overridden by child components
  const defaultTitle = 'ScribeTok - TikTok Transcription Tool';
  const defaultDescription = 'Convert TikTok videos to readable transcripts instantly';
  const defaultImage = 'https://scribetok.com/og-image.jpg'; // Replace with your actual default image
  return <div className="min-h-screen bg-background flex flex-col md:flex-row" data-id="element-468">
      {/* Default meta tags for SEO and link previews */}
      <Helmet data-id="element-469">
        <title data-id="element-470">{defaultTitle}</title>
        <meta name="description" content={defaultDescription} data-id="element-471" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-472" />
        <meta property="og:url" content={window.location.href} data-id="element-473" />
        <meta property="og:title" content={defaultTitle} data-id="element-474" />
        <meta property="og:description" content={defaultDescription} data-id="element-475" />
        <meta property="og:image" content={defaultImage} data-id="element-476" />
        <meta property="og:site_name" content="ScribeTok" data-id="element-477" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-478" />
        <meta name="twitter:title" content={defaultTitle} data-id="element-479" />
        <meta name="twitter:description" content={defaultDescription} data-id="element-480" />
        <meta name="twitter:image" content={defaultImage} data-id="element-481" />
      </Helmet>
      <Navigation onLogout={onLogout} data-id="element-482" />
      <main className="flex-1 overflow-auto pb-20 md:pb-0 transition-all duration-200" data-id="element-483">
        <div className="animate-fade-in" data-id="element-484">
          <Outlet data-id="element-485" />
        </div>
      </main>
    </div>;
}